"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WithAdditionalContent_1 = require("./WithAdditionalContent/WithAdditionalContent");

exports.WithAdditionalContent = WithAdditionalContent_1.default;